import styled from 'styled-components';
import tw from 'twin.macro';
import { NavLink } from 'react-router-dom';
import ScrollBar from '../basic/ScrollBar';

export const SideMenuContainer = styled.div`
    ${tw`flex flex-col flex-1 py-5 pl-2 pr-5`}
`;

export const StyledSideMenu = styled(ScrollBar)`
    ${tw`fixed flex-col w-64 py-3 pl-3 pr-2 top-header min-h-container max-h-container`}
`

export const StyledSideMenuLink = styled(NavLink)`
    ${tw`flex items-center justify-between w-full py-3 pl-4 pr-2 mb-2 text-base bg-opacity-50 border rounded-md ring-1 ring-black ring-opacity-5 bg-secondary-light hover:bg-opacity-70 border-secondary-light focus:outline-none`}

    &.active {
        ${tw`shadow-md bg-opacity-5 hover:bg-opacity-20`}
    }
`;